/**
 * 全局配置
 */

export const config = {
  // Mock 模式开关 - 通过环境变量控制
  mock: import.meta.env.VITE_MOCK === 'true',
  
  // API 基础地址
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  
  // 其他配置项
  appName: 'WMS',
  version: '1.0.0',
};

export default config;
